export const stringWithoutSpecialCharacters = string =>
  string?.replace(/[^a-zA-Z0-9]/g, '').toLowerCase() ?? ''
